export default __webpack_public_path__ + "static/media/base-station.165639cf.svg";